import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { AiTwotoneApi } from 'react-icons/ai';
import { GoRocket } from 'react-icons/go';
import { BsPalette } from 'react-icons/bs';

const articles = [
  {
    icon: <GoRocket />,
    title: 'Getting Started',
    text: 'Whether you are new or a power user, this article will help you get started.',
    link: 'https://docs.printcart.com/docs/users-manual/get-started',
  },
  {
    icon: <AiTwotoneApi />,
    title: 'Printcart API',
    text: 'Determine the authentication method required by the Printcart API.',
    link: 'https://docs.printcart.com/docs/api-reference/intro',
  },
  {
    icon: <BsPalette />,
    title: 'Online Design',
    text: 'Learn how to add the Printcart Online Design App to your store.',
    link: 'https://docs.printcart.com/docs/users-manual/online-design',
  },
];

const HelpInfo = () => (
  <Container fluid className="help-info bg-light mb-3 mt-4">
    <h4 className="mb-3 mt-4">Documentation</h4>
    <p className="text-muted mt-1 mb-2">
      If you have any questions or issues, feel free to search for answers or contact
      support by clicking the chat icon at the bottom-right of the screen.
    </p>
    <Row className="mb-2">
      {articles.map((article, index) => (
        <Col key={index} md={4} className="text-center mb-3">
          <Card className="h-100">
            <Card.Body className="content-wrapper d-flex flex-column">
              <div className="fa-5x mb-4 mt-5">{article.icon}</div>
              <Card.Title className="project-title">{article.title}</Card.Title>
              <Card.Text className="text-center">{article.text}</Card.Text>
            </Card.Body>
            <div className="d-flex justify-content-center mb-3">
              <a
                className="btn btn-primary"
                href={article.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: '150px' }}
              >
                View Detail
              </a>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
);

export default HelpInfo;
